(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customize-logo-tool"] && !Shopify.designMode) return;
  try {
    

(function(){
  const section = document.querySelector('.customize-tool-section');
  if(!section) return;
  function realBackground(startEl){
    let el = startEl;
    while(el && el !== document.documentElement){
      const bg = getComputedStyle(el).backgroundColor;
      if(bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
      el = el.parentElement;
    }
    return getComputedStyle(document.body).backgroundColor;
  }
  void realBackground;
})();

/* ---------------------------------------------------------
   CATEGORY REGISTRY
   Every category this tool could ever show a chip for, in display
   order. Only categories with a matching CATALOG_SHELL entry AND at
   least one qualifying product are ever selectable — everything else
   renders as a disabled "Soon" chip automatically. To bring a new
   category online: add its collection/MOQ settings to the schema,
   add its Liquid catalog block above, add its pricing to
   CATALOG_SHELL below, then add one line here. Nothing else needs
   to change — the chip row and the coming-soon copy both regenerate
   themselves off this list plus whatever the catalog JSON reports.
--------------------------------------------------------- */
const CATEGORY_META = [
  { key:'hardhat',           label:'Hard Hats',
    headline:'See your crew in it before you buy',
    sub:'Upload your logo and it shows up on every hard hat below. Free proof before anything prints.' },
  { key:'helmet',            label:'Safety Helmets',
    headline:'See your crew in it before you buy',
    sub:'Upload your logo and it shows up on every safety helmet below. Free proof before anything prints.' },
  { key:'vests', label:'Safety Vests',
    headline:'See your crew in it before you buy',
    sub:'Upload your logo and it shows up on every vest below. Free proof before anything prints.' },  
    { key:'shirts',      label:'Shirts',
    headline:'See your crew in it before you buy',
    sub:'Upload your logo and it shows up on every vest and shirt below. Free proof before anything prints.' },
  { key:'jackets_coveralls', label:'Jackets &amp; Coveralls',
    headline:'See your crew in it before you buy',
    sub:'Upload your logo and it shows up on every jacket and coverall below. Free proof before anything prints.' },

];

/* ---------------------------------------------------------
   Pricing shell — Radians' pad print / full-color pricing tiers.
   Vendor catalog data, not Shopify product data, so it stays here.
   A category only ever becomes selectable once it has BOTH an entry
   here (so a price can be computed) AND products with logo_config
   set in its collection. Add categories here as pricing is defined
   for them — don't add a shell entry with guessed numbers.

   Vests &amp; Shirts, Jackets &amp; Coveralls, 
   deliberately have NO entry here yet even though their collection
   settings and catalog data now exist above — they'll keep showing
   as "Soon" chips (see categoryHasProducts below) until real pricing
   is added.
--------------------------------------------------------- */
const CATALOG_SHELL = {
  hardhat: {
    label: 'Hard Hats', noun: 'hard hat', positions: ['front','back','left','right'],
    methods: {
      padprint: { label:'Standard', colorOptions:[1,2,3,4],
        tiers:[
          { max:100, prices:{1:1.65,2:2.70,3:3.05,4:3.75} },
          { max:300, prices:{1:1.10,2:1.85,3:2.40,4:3.20} },
          { max:Infinity, prices:{1:0.90,2:1.40,3:1.75,4:2.15} },
        ]},
      pvc: { label:'Full-color',
        tiers:[ { max:100, price:2.95 }, { max:300, price:1.95 }, { max:Infinity, price:1.95 } ]}
    }
  },
  helmet: {
    label: 'Safety Helmets', noun: 'safety helmet', positions: ['front','back','left','right'],
    methods: {
      padprint: { label:'Standard', colorOptions:[1,2,3,4],
        tiers:[
          { max:71, prices:{1:3.15,2:3.65,3:4.05,4:4.55} },
          { max:Infinity, prices:{1:2.55,2:3.05,3:3.55,4:4.05} },
        ]},
      pvc: { label:'Full-color',
        tiers:[ { max:71, price:2.95 }, { max:Infinity, price:1.95 } ]}
    }
  },
  vests: {
    label: 'Vests', noun: 'vest', 
    positions: ['left_pocket','right_pocket','back_top','back_bottom'],
    methods: {
      padprint: { label:'Standard', colorOptions:[1,2,3,4],
        tiers:[
          { max:100, prices:{1:2.50,2:3.50,3:4.50,4:5.50} },
          { max:Infinity, prices:{1:1.75,2:2.50,3:3.50,4:4.50} }
        ]},
      pvc: { label:'Full-color',
        tiers:[ { max:100, price:3.50 }, { max:Infinity, price:2.50 } ]}
    }
  },
  shirts: {
    label: 'Shirts', noun: 'shirt', 
    positions: ['left_pocket','right_pocket','back_top','back_bottom'],
    methods: {
      padprint: { label:'Standard', colorOptions:[1,2,3,4],
        tiers:[
          { max:100, prices:{1:2.50,2:3.50,3:4.50,4:5.50} },
          { max:Infinity, prices:{1:1.75,2:2.50,3:3.50,4:4.50} }
        ]},
      pvc: { label:'Full-color',
        tiers:[ { max:100, price:3.50 }, { max:Infinity, price:2.50 } ]}
    }
  }
};

const catalogDataEl = document.getElementById('customize-catalog-data');
const catalogData = catalogDataEl ? JSON.parse(catalogDataEl.textContent) : {};

const CATALOG = {};
Object.keys(CATALOG_SHELL).forEach(key => {
  const real = catalogData[key] || {};
  CATALOG[key] = {
    ...CATALOG_SHELL[key],
    moq: real.moq || 1,
    maxDims: real.maxDims || null,
    products: real.products || [],
  };
});

/* A category is live only once it has pricing wired (CATALOG_SHELL
   entry) AND at least one product with logo_config configured. This
   is the single source of truth the chip row, the coming-soon note,
   and the default-selected category all read from. */
function categoryHasProducts(key){
  return !!(CATALOG[key] && CATALOG[key].products && CATALOG[key].products.length > 0);
}

function money(n){ return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function titleCase(s){ return s[0].toUpperCase() + s.slice(1); }
function tierFor(tiers, qty){ return tiers.find(t => qty <= t.max) || tiers[tiers.length-1]; }
const LOGO_PRICE_MARGIN = 1.25; // 25% markup (1.0 = no markup, 1.25 = +25%)

function unitPriceFor(category, method, colors, qty){
  const m = CATALOG[category].methods[method];
  const tier = tierFor(m.tiers, qty);
  const basePrice = method === 'padprint' ? tier.prices[colors] : tier.price;
  return basePrice * LOGO_PRICE_MARGIN; // Apply margin here
}
function nextBreakFor(category, method, colors, qty){
  const tiers = CATALOG[category].methods[method].tiers;
  for(let i=0;i<tiers.length;i++){
    if(qty <= tiers[i].max && tiers[i].max !== Infinity){
      const nextQty = tiers[i].max + 1;
      const here = unitPriceFor(category, method, colors, qty);
      const there = unitPriceFor(category, method, colors, nextQty);
      if(there < here) return { nextQty, add: nextQty - qty, price: there };
      return null;
    }
  }
  return null;
}

function adj(m){
  return [
    m[4]*m[8]-m[5]*m[7], m[2]*m[7]-m[1]*m[8], m[1]*m[5]-m[2]*m[4],
    m[5]*m[6]-m[3]*m[8], m[0]*m[8]-m[2]*m[6], m[2]*m[3]-m[0]*m[5],
    m[3]*m[7]-m[4]*m[6], m[1]*m[6]-m[0]*m[7], m[0]*m[4]-m[1]*m[3]
  ];
}
function multiply(a,b){
  const c = new Array(9);
  for(let i=0;i<3;i++) for(let j=0;j<3;j++){
    let s=0; for(let k=0;k<3;k++) s += a[3*i+k]*b[3*k+j];
    c[3*i+j]=s;
  }
  return c;
}
function multiplyVec(m,v){
  return [ m[0]*v[0]+m[1]*v[1]+m[2]*v[2], m[3]*v[0]+m[4]*v[1]+m[5]*v[2], m[6]*v[0]+m[7]*v[1]+m[8]*v[2] ];
}
function basisToPoints(x1,y1,x2,y2,x3,y3,x4,y4){
  const m = [x1,x2,x3, y1,y2,y3, 1,1,1];
  const v = multiplyVec(adj(m), [x4,y4,1]);
  return multiply(m, [v[0],0,0, 0,v[1],0, 0,0,v[2]]);
}
function project(w,h, p1,p2,p3,p4){
  const s = basisToPoints(0,0, w,0, w,h, 0,h);
  const d = basisToPoints(p1.x,p1.y, p2.x,p2.y, p3.x,p3.y, p4.x,p4.y);
  let t = multiply(d, adj(s));
  for(let i=0;i<9;i++) t[i] = t[i]/t[8];
  return `matrix3d(${t[0]},${t[3]},0,${t[6]}, ${t[1]},${t[4]},0,${t[7]}, 0,0,1,0, ${t[2]},${t[5]},0,${t[8]})`;
}
const REF_W = 300, REF_H = 180;
const ROOT = document.getElementById('customizeToolRoot');
const DEFAULT_LOGO_SRC = ROOT.dataset.defaultLogoSrc || '';
const CONTACT_PHONE = ROOT.dataset.contactPhone || '';
const CONTACT_EMAIL = ROOT.dataset.contactEmail || '';
const CONTACT_URL = ROOT.dataset.contactUrl || '/pages/contact-us';
const SUBMIT_ENDPOINT = ROOT.dataset.submitEndpoint || '';

function removeFlatBackground(dataURL){
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const id = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = id.data;
      const corners = [[0,0],[canvas.width-1,0],[0,canvas.height-1],[canvas.width-1,canvas.height-1]];
      let br=0,bg=0,bb=0;
      corners.forEach(([x,y]) => { const i=(y*canvas.width+x)*4; br+=d[i]; bg+=d[i+1]; bb+=d[i+2]; });
      br/=4; bg/=4; bb/=4;
      const threshold = 30, feather = 22;
      for(let i=0;i<d.length;i+=4){
        const dr=d[i]-br, dg=d[i+1]-bg, db=d[i+2]-bb;
        const dist = Math.sqrt(dr*dr+dg*dg+db*db);
        if(dist < threshold) d[i+3] = 0;
        else if(dist < threshold+feather) d[i+3] = Math.round(d[i+3] * (dist-threshold)/feather);
      }
      ctx.putImageData(id, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = dataURL;
  });
}

function recolorToStockColor(dataURL, hex){
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const id = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = id.data;
      const corners = [[0,0],[canvas.width-1,0],[0,canvas.height-1],[canvas.width-1,canvas.height-1]];
      let br=0,bg=0,bb=0;
      corners.forEach(([x,y]) => { const i=(y*canvas.width+x)*4; br+=d[i]; bg+=d[i+1]; bb+=d[i+2]; });
      br/=4; bg/=4; bb/=4;
      const threshold = 30, feather = 22;
      const tr = parseInt(hex.slice(1,3),16), tg = parseInt(hex.slice(3,5),16), tb = parseInt(hex.slice(5,7),16);
      for(let i=0;i<d.length;i+=4){
        const dr=d[i]-br, dg=d[i+1]-bg, db=d[i+2]-bb;
        const dist = Math.sqrt(dr*dr+dg*dg+db*db);
        let alpha = d[i+3];
        if(dist < threshold) alpha = 0;
        else if(dist < threshold+feather) alpha = Math.round(alpha * (dist-threshold)/feather);
        d[i]=tr; d[i+1]=tg; d[i+2]=tb; d[i+3]=alpha;
      }
      ctx.putImageData(id, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = dataURL;
  });
}

function isSingleColorRecolorable(p){
  return p.method === 'padprint' && p.colors === 1 && p.colorSlots[0] && p.colorSlots[0].kind === 'stock';
}

function refreshLogoPreview(p){
  if(!p.fileData){ p.displayData = null; p.recolored = false; renderPreview(); return; }

  if(isSingleColorRecolorable(p)){
    p.processing = true; renderPlacements();
    const hex = stockColorByName(p.colorSlots[0].value).hex;
    recolorToStockColor(p.fileData, hex).then(result => {
      p.displayData = result; p.recolored = true; p.processing = false;
      renderPlacements(); renderPreview();
    });
    return;
  }

  p.recolored = false;
  if(!p.bgRemoved){ p.displayData = p.fileData; renderPreview(); return; }
  p.processing = true; renderPlacements();
  removeFlatBackground(p.fileData).then(processed => {
    p.displayData = processed; p.processing = false;
    renderPlacements(); renderPreview();
  });
}

let state = { type:null, product:null, color:null };
let placements = [];
let pIdCounter = 0;
let currentAngleId = null;
let colorPanelOpen = false;
let step2Unlocked = false, step3Unlocked = false;
let requestNumber = null;

const isMobile = () => window.matchMedia('(max-width:760px)').matches;

const catRow = document.getElementById('catRow');
const soonNote = document.getElementById('soonNote');
const modelGrid = document.getElementById('modelGrid');
const modelCount = document.getElementById('modelCount');
const selectBar = document.getElementById('selectBar');
const selectBarName = document.getElementById('selectBarName');
const step1Continue = document.getElementById('step1Continue');
const placementList = document.getElementById('placementList');
const addPlacementBtn = document.getElementById('addPlacementBtn');
const qtyInput = document.getElementById('qtyInput');
const qtyNote = document.getElementById('qtyNote');
const priceBreakNote = document.getElementById('priceBreakNote');
const ctaBtn = document.getElementById('ctaBtn');
const mobileBar = document.getElementById('mobileBar');
const mobileBarInfo = document.getElementById('mobileBarInfo');
const mobileCtaBtn = document.getElementById('mobileCtaBtn');
const priceBreakdown = document.getElementById('priceBreakdown');
const estimateDetails = document.getElementById('estimateDetails');
const estimateHint = document.getElementById('estimateHint');
const totalAmt = document.getElementById('totalAmt');
const previewStage = document.getElementById('previewStage');
const previewCaption = document.getElementById('previewCaption');
const angleTabs = document.getElementById('angleTabs');

const STOCK_COLORS = [
  { name:'Yellow',      pms:'102 C',  hex:'#F7EA48' },
  { name:'Hot Yellow',  pms:'137 C',  hex:'#FFA400' },
  { name:'Orange',      pms:'165 C',  hex:'#FF6900' },
  { name:'Bright Red',  pms:'186 C',  hex:'#C8102E' },
  { name:'Carmin Red',  pms:'193 C',  hex:'#C6004A' },
  { name:'Maroon',      pms:'194 C',  hex:'#6F263D' },
  { name:'Light Blue',  pms:'299 C',  hex:'#00A9E0' },
  { name:'Royal Blue',  pms:'301 C',  hex:'#00539B' },
  { name:'Dark Blue',   pms:'289 C',  hex:'#041E42' },
  { name:'Violet',      pms:'2755 C', hex:'#3B3269' },
  { name:'Light Green', pms:'348 C',  hex:'#00843D' },
  { name:'Pine Green',  pms:'350 C',  hex:'#205C40' },
  { name:'Dark Brown',  pms:'4695 C', hex:'#4A3728' },
  { name:'White',       pms:null,     hex:'#FFFFFF' },
  { name:'Gray',        pms:null,     hex:'#A2AAAD' },
  { name:'Black',       pms:null,     hex:'#000000' },
  { name:'Gold',        pms:'874 U',  hex:'#A69364' },
];
function stockColorByName(name){ return STOCK_COLORS.find(c => c.name === name) || STOCK_COLORS[15]; }
function stockColorLabel(c){ return c.pms ? `${c.name} · PMS ${c.pms}` : c.name; }

function makeColorSlots(count, existing){
  const slots = [];
  for(let i=0;i<count;i++){
    slots.push(existing && existing[i] ? existing[i] : { kind:'stock', value:'Black' });
  }
  return slots;
}

function goToStep(n){
  document.querySelectorAll('.customize-tool-section .panel').forEach(p => p.classList.remove('active'));
  const panel = document.getElementById('panel'+n);
  if(panel) panel.classList.add('active');
  document.querySelectorAll('.step-item').forEach(el => {
    const s = parseInt(el.dataset.goto);
    el.classList.toggle('active', s === n);
    el.classList.toggle('done', s < n);
    el.classList.toggle('clickable', s < n || (s===2 && step2Unlocked) || (s===3 && step3Unlocked));
  });
  document.getElementById('changeSelectionBtn').style.display = (n === 2) ? 'inline-block' : 'none';
  document.getElementById('stepper').style.display = (n === 4) ? 'none' : '';
  document.getElementById('toolHero').style.display = (n === 1) ? '' : 'none';
  mobileBar.style.display = (n === 2 && isMobile()) ? '' : 'none';
  if(n === 2) mobileBar.style.display = '';
  else mobileBar.style.display = 'none';
  window.scrollTo({ top: ROOT.getBoundingClientRect().top + window.scrollY - 20, behavior:'smooth' });
}
document.querySelectorAll('.step-item').forEach(el => {
  el.addEventListener('click', () => {
    const n = parseInt(el.dataset.goto);
    if(n === 1) goToStep(1);
    if(n === 2 && step2Unlocked) goToStep(2);
    if(n === 3 && step3Unlocked) goToStep(3);
  });
});

/* ---------------------------------------------------------
   STEP 1 — categories (dynamic) + model grid (color NOT chosen here)
--------------------------------------------------------- */
function renderCatRow(){
  const liveKeys = CATEGORY_META.filter(m => categoryHasProducts(m.key)).map(m => m.key);
  const soonLabels = CATEGORY_META.filter(m => !categoryHasProducts(m.key)).map(m => m.label);

  if(!state.type || !categoryHasProducts(state.type)){
    state.type = liveKeys[0] || CATEGORY_META[0].key;
  }

  catRow.innerHTML = CATEGORY_META.map(m => {
    const live = categoryHasProducts(m.key);
    return `<button class="cat-chip ${state.type===m.key?'active':''} ${live?'':'disabled'}" data-type="${m.key}">
      ${m.label}${live ? '' : ' <span class="soon">Soon</span>'}
    </button>`;
  }).join('');

  catRow.querySelectorAll('.cat-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      const key = chip.dataset.type;
      if(!categoryHasProducts(key)) return;
      state.type = key; state.product = null; state.color = null;
      renderCatRow();
      renderModelGrid();
      selectBar.style.display = 'none';
    });
  });

  updateHeadline();
  soonNote.innerHTML = soonLabels.length
    ? `Coming soon: ${soonLabels.join(', ')}. <a href="${CONTACT_URL}">Ask us</a> if you need one of those now.`
    : '';
}

function defaultColorFor(prod){
  if(!prod.colors || prod.colors.length === 0) return null;
  // Try white first (case-insensitive), then any color with angles, then fallback
  return prod.colors.find(c => c.name && c.name.toLowerCase() === 'white' && c.angles && c.angles.length)
      || prod.colors.find(c => c.angles && c.angles.length)
      || prod.colors[0];
}
function firstPhotoFor(prod){
  // Prioritize white variant if available, otherwise use first color with photos
  const whiteColor = prod.colors && prod.colors.find(c => c.name && c.name.toLowerCase() === 'white' && c.angles && c.angles.length);
  if(whiteColor && whiteColor.angles && whiteColor.angles.length) return whiteColor.angles[0].src;
  
  for(const c of prod.colors){ if(c.angles && c.angles.length) return c.angles[0].src; }
  return null;
}

function renderModelGrid(){
  const cat = CATALOG[state.type];
  if(!cat){
    modelCount.textContent = '';
    modelGrid.innerHTML = '<div class="preview-empty">No products are set up for the logo tool in this category yet.</div>';
    return;
  }
  modelCount.textContent = `${cat.products.length} ${cat.noun}${cat.products.length===1?'':'s'} · ${cat.moq} unit minimum`;
  modelGrid.innerHTML = '';
  if(cat.products.length === 0){
    modelGrid.innerHTML = '<div class="preview-empty">No products are set up for the logo tool in this collection yet.</div>';
    return;
  }
  cat.products.forEach(prod => {
    const card = document.createElement('div');
    card.className = 'model-card' + (state.product && state.product.id === prod.id ? ' selected' : '');
    const photo = firstPhotoFor(prod);
    const hasColors = prod.colors && prod.colors.length > 0;
    const stack = hasColors ? prod.colors.slice(0,4).map(c => `<span style="background:${c.hex}"></span>`).join('') : '';
    card.innerHTML = `
      <div class="model-photo">
        ${photo ? `<img src="${photo}" alt="${prod.name}">` : (hasColors ? `<div class="swatch-fallback"><span style="background:${prod.colors[0].hex}"></span></div>` : '')}
        ${state.product && state.product.id === prod.id ? '<div class="model-badge">Selected</div>' : ''}
      </div>
      <div class="model-name">${prod.shortName || prod.name}</div>
      <div class="model-price">${money(prod.price)} ea</div>
      <div class="model-logo-price">${logoFromLabel(state.type)}</div>
      <div class="model-colors">
        <span class="swatch-stack">${stack}</span>
        <span class="color-count">${hasColors ? prod.colors.length : 0} color${hasColors && prod.colors.length===1?'':'s'}</span>
      </div>
      ${prod.dewalt ? '<div class="dewalt-flag">Back logo unavailable on DEWALT</div>' : ''}
      ${state.product && state.product.id === prod.id ? `<button class="cta model-go" type="button">${globalLogo ? 'Place my logo &rarr;' : 'Customize this &rarr;'}</button>` : ''}
    `;
    card.addEventListener('click', (e) => {
      if(e.target.closest('.model-go')){ startCustomizing(); return; }
      if(state.product && state.product.id === prod.id) return;
      state.product = prod;
      state.color = defaultColorFor(prod);
      renderModelGrid();
      selectBarName.textContent = `${prod.shortName || prod.name} — ${money(prod.price)} ea`;
    });
    modelGrid.appendChild(card);
    paintCardLogo(card, prod);
  });
}

function startCustomizing(){
  if(!state.product) return;
  placements = []; pIdCounter = 0;
  qtyInput.value = CATALOG[state.type].moq;
  currentAngleId = null; colorPanelOpen = false;
  step2Unlocked = true;
  addPlacement();
  goToStep(2);
  render();
}
step1Continue.addEventListener('click', startCustomizing);
document.getElementById('changeSelectionBtn').addEventListener('click', () => goToStep(1));

let uploadModal = { placementId:null, fileName:null, fileData:null, bgRemoved:false };
const uploadModalOverlay = document.getElementById('uploadModalOverlay');
const uploadModalTitle = document.getElementById('uploadModalTitle');
const uploadModalBody = document.getElementById('uploadModalBody');
const uploadModalSave = document.getElementById('uploadModalSave');

function openUploadModal(placementId){
  const p = placements.find(x => x.id == placementId);
  uploadModal = { placementId, fileName: p.fileName, fileData: p.fileData, bgRemoved: p.bgRemoved };
  uploadModalTitle.textContent = `Upload your ${p.position} logo`;
  renderUploadModal();
  uploadModalOverlay.classList.add('open');
}
function closeUploadModal(){ uploadModalOverlay.classList.remove('open'); }

function renderUploadModal(){
  const cat = CATALOG[state.type];
  const maxDimsNote = cat.maxDims
    ? `<div class="modal-note">Max logo size for ${cat.label.toLowerCase()}: ${cat.maxDims.label}</div>`
    : '';

  if(!uploadModal.fileData){
    uploadModalBody.innerHTML = `
      <label class="modal-dropzone">
        Click to choose a logo file<br>PNG or JPG works great
        <input type="file" id="modalFileInput" accept="image/*" style="display:none;">
      </label>
      ${maxDimsNote}
    `;
  } else {
    uploadModalBody.innerHTML = `
      <div class="modal-preview">
        <div class="modal-preview-thumb"><img src="${uploadModal.fileData}" alt=""></div>
        <div class="modal-preview-info">
          <div class="fname">${uploadModal.fileName}</div>
          <button class="modal-change-link" id="modalChangeFile">Choose a different file</button>
        </div>
      </div>
      ${maxDimsNote}
      <div class="modal-note">If this is a 1-color logo, it'll automatically preview in your selected ink color — no need to remove the background yourself.</div>
      <label class="modal-bgrow">
        <input type="checkbox" id="modalBgRemove" ${uploadModal.bgRemoved?'checked':''}>
        <span>Remove the background from this file (useful if it's not already transparent and has a plain backdrop)</span>
      </label>
    `;
    document.getElementById('modalChangeFile').onclick = () => {
      uploadModal.fileData = null; uploadModal.fileName = null;
      renderUploadModal();
    };
    document.getElementById('modalBgRemove').onchange = (e) => { uploadModal.bgRemoved = e.target.checked; };
  }

  const fileInput = document.getElementById('modalFileInput');
  if(fileInput){
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      if(!file) return;
      uploadModal.fileName = file.name;
      const reader = new FileReader();
      reader.onload = (evt) => { uploadModal.fileData = evt.target.result; renderUploadModal(); };
      reader.readAsDataURL(file);
    };
  }

  uploadModalSave.disabled = !uploadModal.fileData;
}

document.getElementById('uploadModalClose').onclick = closeUploadModal;
document.getElementById('uploadModalCancel').onclick = closeUploadModal;
uploadModalOverlay.addEventListener('click', (e) => { if(e.target === uploadModalOverlay) closeUploadModal(); });
uploadModalSave.addEventListener('click', () => {
  const p = placements.find(x => x.id == uploadModal.placementId);
  p.fileName = uploadModal.fileName;
  p.fileData = uploadModal.fileData;
  p.bgRemoved = uploadModal.bgRemoved;
  closeUploadModal();
  render();
  refreshLogoPreview(p);
});

function availablePositions(){
  const cat = CATALOG[state.type];
  const used = placements.map(p => p.position);
  return cat.positions.filter(pos => {
    if(used.includes(pos)) return false;
    if(state.product.dewalt && pos === 'back') return false;
    return true;
  });
}
function addPlacement(){
  const avail = availablePositions();
  if(avail.length === 0) return;
  placements.forEach(p => { p.collapsed = true; });
  placements.push({ id: ++pIdCounter, position: avail[0], method:'padprint', colors:1, colorSlots: makeColorSlots(1), fileName:null, fileData:null, displayData:null, bgRemoved:false, recolored:false, processing:false, collapsed:false });
  applyGlobalLogoTo(placements[placements.length - 1]);
  render();
}
addPlacementBtn.addEventListener('click', addPlacement);
function removePlacement(id){ placements = placements.filter(p => p.id !== id); render(); }

function colorSummaryFor(p){
  if(p.method !== 'padprint') return 'Full-color PVC';
  const names = p.colorSlots.map(s => s.kind==='stock' ? s.value : (s.value.trim() || 'custom color'));
  return `Standard · ${p.colors} color${p.colors>1?'s':''}, ${names.join(', ')}`;
}

const TRASH_SVG = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';

function renderPlacements(){
  placementList.innerHTML = '';
  const cat = CATALOG[state.type];
  const qty = parseInt(qtyInput.value) || cat.moq;

  placements.forEach(p => {
    const div = document.createElement('div');
    const thumbSrc = p.fileData ? (p.displayData || p.fileData) : DEFAULT_LOGO_SRC;

    if(p.collapsed){
      div.className = 'placement placement-collapsed';
      div.innerHTML = `
        <div class="collapsed-thumb">${p.fileName ? `<img src="${thumbSrc}" alt="">` : `<div class="thumb-empty">Add<br>logo</div>`}</div>
        <div class="collapsed-info">
          <div class="placement-title">${titleCase(p.position)} logo</div>
          <div class="placement-sub">${colorSummaryFor(p)}${p.fileName ? '' : ' · no logo yet'}</div>
        </div>
        <span class="collapsed-price" data-summary-price="${p.id}"></span>
        <button class="collapsed-edit" data-edit="${p.id}">Edit</button>
        <button class="placement-remove" data-remove="${p.id}" title="Remove this logo">${TRASH_SVG}</button>
      `;
      placementList.appendChild(div);
      return;
    }

    div.className = 'placement open';
    const posOptions = cat.positions.map(pos => {
      const disabled = (pos !== p.position && placements.some(x => x.position === pos)) || (state.product.dewalt && pos === 'back' && pos !== p.position);
      return `<option value="${pos}" ${pos===p.position?'selected':''} ${disabled?'disabled':''}>${titleCase(pos)}</option>`;
    }).join('');

    let body = '';
    if(!p.fileName){
      body = `<div class="upload-first-hint">Upload a logo to choose print type and color.</div>`;
    } else {
      const stdUnit = unitPriceFor(state.type, 'padprint', p.colors, qty);
      const pvcUnit = unitPriceFor(state.type, 'pvc', p.colors, qty);
      const costFlag = (p.method === 'padprint' && pvcUnit < stdUnit)
        ? `<div class="cost-flag">Full-color would be <strong>${money(stdUnit - pvcUnit)} cheaper per unit</strong> at this quantity and color count.<button class="cost-flag-switch" data-switch-pvc="${p.id}">Switch to full-color</button></div>`
        : '';

      const colorSlots = p.method === 'padprint' ? `
        <div class="color-slots">
          ${p.colorSlots.map((slot, idx) => `
            <div class="color-slot">
              <span class="color-swatch-dot" style="background:${slot.kind==='stock' ? stockColorByName(slot.value).hex : '#ccc'}"></span>
              <select data-slot-kind="${p.id}:${idx}">
                ${STOCK_COLORS.map(c => `<option value="${c.name}" ${slot.kind==='stock'&&slot.value===c.name?'selected':''}>${stockColorLabel(c)}</option>`).join('')}
                <option value="__custom__" ${slot.kind==='custom'?'selected':''}>Don't see your color?…</option>
              </select>
              ${slot.kind==='custom' ? `<input type="text" placeholder="Describe the color or PMS # if known" value="${slot.value==='__custom__'?'':slot.value}" data-slot-value="${p.id}:${idx}">` : ''}
              ${idx>0 ? `<button class="slot-remove" data-slot-remove="${p.id}:${idx}" title="Remove this color">&#10005;</button>` : ''}
            </div>
          `).join('')}
          ${p.colors < 4 ? `<button class="add-color-link" data-add-color="${p.id}">+ This logo has another color</button>` : ''}
        </div>` : '';

      const note = isSingleColorRecolorable(p)
        ? `<div class="recolor-note ${p.processing?'processing':''}">${p.processing ? 'Updating preview…' : `Shown in ${p.colorSlots[0].value} to match your selection.`}</div>`
        : `<div class="colors-note">Multi-color logos preview in their original artwork colors — we'll confirm exact colors with you before printing.</div>`;

      body = `
        <div class="method-row">
          <button class="method-btn ${p.method==='padprint'?'active':''}" data-method="padprint" data-id="${p.id}">
            <span class="method-btn-name">Standard</span><span class="method-btn-price">+${money(stdUnit)} ea</span>
          </button>
          <button class="method-btn ${p.method==='pvc'?'active':''}" data-method="pvc" data-id="${p.id}">
            <span class="method-btn-name">Full-color</span><span class="method-btn-price">+${money(pvcUnit)} ea</span>
          </button>
        </div>
        <div class="method-hint">${p.method==='padprint'
          ? 'Standard suits solid-color logos with no gradients or photos. Most affordable.'
          : 'For detailed or photo-quality logos with gradients or many colors.'}</div>
        ${colorSlots}
        ${costFlag}
        ${note}
      `;
    }

    div.innerHTML = `
      <div class="placement-head">
        <div class="thumb-wrap" data-open-upload="${p.id}">
          ${p.fileName ? `<img class="placement-thumb" src="${thumbSrc}" alt="">` : `<div class="thumb-empty">Add<br>logo</div>`}
          <span class="thumb-edit-badge">
            <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
          </span>
        </div>
        <div class="placement-headinfo">
          <select class="pos-select" data-id="${p.id}">${posOptions}</select>
          <div class="placement-sub">${p.fileName || 'No logo uploaded yet'}</div>
        </div>
        <button class="placement-remove" data-remove="${p.id}" title="Remove this logo">${TRASH_SVG}</button>
      </div>
      ${body}
      <div class="placement-footer">
        <span class="placement-unit-price" data-price="${p.id}"></span>
        <button class="save-placement-btn" data-save="${p.id}">Save</button>
      </div>
    `;
    placementList.appendChild(div);
  });

  placementList.querySelectorAll('.pos-select').forEach(sel => {
    sel.onchange = () => { placements.find(x => x.id == sel.dataset.id).position = sel.value; render(); };
  });
  placementList.querySelectorAll('[data-remove]').forEach(btn => {
    btn.onclick = () => removePlacement(parseInt(btn.dataset.remove));
  });
  placementList.querySelectorAll('[data-save]').forEach(btn => {
    btn.onclick = () => { placements.find(x => x.id == btn.dataset.save).collapsed = true; render(); };
  });
  placementList.querySelectorAll('[data-edit]').forEach(btn => {
    btn.onclick = () => { placements.find(x => x.id == btn.dataset.edit).collapsed = false; render(); };
  });
  placementList.querySelectorAll('.method-btn').forEach(btn => {
    btn.onclick = () => {
      const p = placements.find(x => x.id == btn.dataset.id);
      p.method = btn.dataset.method;
      render(); refreshLogoPreview(p);
    };
  });
  placementList.querySelectorAll('[data-add-color]').forEach(btn => {
    btn.onclick = () => {
      const p = placements.find(x => x.id == btn.dataset.addColor);
      p.colors = Math.min(4, p.colors + 1);
      p.colorSlots = makeColorSlots(p.colors, p.colorSlots);
      render(); refreshLogoPreview(p);
    };
  });
  placementList.querySelectorAll('[data-slot-remove]').forEach(btn => {
    btn.onclick = () => {
      const [pid, idx] = btn.dataset.slotRemove.split(':');
      const p = placements.find(x => x.id == pid);
      p.colorSlots.splice(idx, 1);
      p.colors = p.colorSlots.length;
      render(); refreshLogoPreview(p);
    };
  });
  placementList.querySelectorAll('[data-slot-kind]').forEach(sel => {
    sel.onchange = () => {
      const [pid, idx] = sel.dataset.slotKind.split(':');
      const p = placements.find(x => x.id == pid);
      if(sel.value === '__custom__') p.colorSlots[idx] = { kind:'custom', value:'' };
      else p.colorSlots[idx] = { kind:'stock', value: sel.value };
      render(); refreshLogoPreview(p);
    };
  });
  placementList.querySelectorAll('[data-slot-value]').forEach(input => {
    input.oninput = () => {
      const [pid, idx] = input.dataset.slotValue.split(':');
      placements.find(x => x.id == pid).colorSlots[idx].value = input.value;
      updatePricing();
    };
  });
  placementList.querySelectorAll('[data-switch-pvc]').forEach(btn => {
    btn.onclick = () => {
      const p = placements.find(x => x.id == btn.dataset.switchPvc);
      p.method = 'pvc';
      render(); refreshLogoPreview(p);
    };
  });
  placementList.querySelectorAll('[data-open-upload]').forEach(btn => {
    btn.onclick = () => openUploadModal(btn.dataset.openUpload);
  });

  const noneLeft = availablePositions().length === 0;
  addPlacementBtn.disabled = noneLeft;
  addPlacementBtn.textContent = noneLeft ? 'All available positions added' : '+ Add another logo location';
}

const OBJECT_POSITION = { x: 50, y: 38 };
function coverTransform(containerW, containerH){
  const img = previewStage.querySelector('.product-photo');
  if(!img || !img.naturalWidth) return { scale:1, offsetX:0, offsetY:0, dw:containerW, dh:containerH };
  const nw = img.naturalWidth, nh = img.naturalHeight;
  const scale = Math.max(containerW/nw, containerH/nh);
  const dw = nw*scale, dh = nh*scale;
  return {
    scale,
    offsetX: (containerW-dw) * (OBJECT_POSITION.x/100),
    offsetY: (containerH-dh) * (OBJECT_POSITION.y/100),
    dw, dh
  };
}
function pctToPx(pt, w, h){
  const t = coverTransform(w, h);
  return { x: t.offsetX + (pt.x/100)*t.dw, y: t.offsetY + (pt.y/100)*t.dh };
}

function mirrorZone(zone){
  return {
    tl: { x: 100 - zone.tr.x, y: zone.tr.y },
    tr: { x: 100 - zone.tl.x, y: zone.tl.y },
    bl: { x: 100 - zone.br.x, y: zone.br.y },
    br: { x: 100 - zone.bl.x, y: zone.bl.y },
  };
}
function mirrorPositionKey(key){
  if(key === 'left') return 'right';
  if(key === 'right') return 'left';
  return key;
}
function deriveRightAngle(leftAngle){
  const zones = {};
  Object.entries(leftAngle.zones || {}).forEach(([pos, zone]) => { zones[mirrorPositionKey(pos)] = mirrorZone(zone); });
  const scaleRef = leftAngle.scaleRef
    ? { p1: { x: 100 - leftAngle.scaleRef.p1.x, y: leftAngle.scaleRef.p1.y },
        p2: { x: 100 - leftAngle.scaleRef.p2.x, y: leftAngle.scaleRef.p2.y },
        inches: leftAngle.scaleRef.inches }
    : null;
  return { id:'right', label:'Right', src: leftAngle.src, mirrored:true, zones, scaleRef, _borrowed: leftAngle._borrowed };
}
function withDerivedAngles(angles){
  if(angles.some(a => a.id === 'right')) return angles;
  const left = angles.find(a => a.id === 'left');
  return left ? [...angles, deriveRightAngle(left)] : angles;
}

function anglesForColor(){
  if(!state.product) return [];
  const ownAngles = (state.color && state.color.angles) || [];
  const fallbackColor = state.product.colors.find(c => c.name === 'White' && c.angles && c.angles.length > 0)
                      || state.product.colors.find(c => c.angles && c.angles.length > 0);
  const fallbackAngles = fallbackColor ? fallbackColor.angles : [];

  const merged = [];
  const seenIds = new Set();
  ownAngles.forEach(a => { merged.push({ ...a, _borrowed:false }); seenIds.add(a.id); });
  fallbackAngles.forEach(a => { if(!seenIds.has(a.id)){ merged.push({ ...a, _borrowed:true }); seenIds.add(a.id); } });
  return withDerivedAngles(merged);
}
function isPlaceholderPreview(angle){ return !!(angle && angle._borrowed); }
function angleCoversPlacements(angle){ return placements.filter(p => angle.zones && angle.zones[p.position]).length; }
function angleLabel(a){ return (a.id === 'threequarter') ? 'Angle' : a.label; }

const photoMaskCache = new Map();
const MASK_WORK_SIZE = 420;

function hasUsableAlpha(src){
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const w = Math.min(img.naturalWidth, 200), h = Math.min(img.naturalHeight, 200);
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, 0, w, h).data;
        let transparent = 0;
        for(let i=3;i<d.length;i+=4){ if(d[i] < 250) transparent++; }
        resolve((transparent/(w*h)) > 0.02);
      } catch(e){ resolve(false); }
    };
    img.onerror = () => resolve(false);
    img.src = src;
  });
}

function buildFloodFillMask(src){
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const scale = Math.min(1, MASK_WORK_SIZE / Math.max(img.naturalWidth, img.naturalHeight));
        const w = Math.max(1, Math.round(img.naturalWidth * scale));
        const h = Math.max(1, Math.round(img.naturalHeight * scale));
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        const id = ctx.getImageData(0, 0, w, h);
        const d = id.data;

        const bg = new Uint8Array(w*h);
        const visited = new Uint8Array(w*h);
        const stepThreshold = 16;
        const queue = [];
        const seed = (x,y) => { const idx=y*w+x; if(!visited[idx]){ visited[idx]=1; bg[idx]=1; queue.push(idx); } };
        for(let x=0;x<w;x++){ seed(x,0); seed(x,h-1); }
        for(let y=0;y<h;y++){ seed(0,y); seed(w-1,y); }

        let qi = 0;
        while(qi < queue.length){
          const idx = queue[qi++];
          const x = idx % w, y = (idx / w) | 0;
          const i = idx*4, r=d[i], g=d[i+1], b=d[i+2];
          const neighbors = [[x-1,y],[x+1,y],[x,y-1],[x,y+1]];
          for(const [nx,ny] of neighbors){
            if(nx<0||nx>=w||ny<0||ny>=h) continue;
            const nIdx = ny*w+nx;
            if(visited[nIdx]) continue;
            const ni = nIdx*4;
            const dist = Math.sqrt((d[ni]-r)**2 + (d[ni+1]-g)**2 + (d[ni+2]-b)**2);
            if(dist < stepThreshold){ visited[nIdx]=1; bg[nIdx]=1; queue.push(nIdx); }
          }
        }

        let bgCount = 0;
        for(let p=0;p<bg.length;p++) if(bg[p]) bgCount++;
        const bgFraction = bgCount / bg.length;
        if(bgFraction < 0.03 || bgFraction > 0.92){ resolve(null); return; }

        for(let p=0;p<bg.length;p++){ const i=p*4; d[i]=255; d[i+1]=255; d[i+2]=255; d[i+3]= bg[p] ? 0 : 255; }
        ctx.putImageData(id, 0, 0);
        ctx.filter = 'blur(1.5px)';
        ctx.drawImage(canvas, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch(e){ resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

function mirrorMaskImage(dataURL){
  return new Promise((resolve) => {
    if(!dataURL){ resolve(null); return; }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch(e){ resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = dataURL;
  });
}

function getPhotoMask(angle){
  const cacheKey = angle.src;
  let entry = photoMaskCache.get(cacheKey);
  if(!entry){
    entry = {};
    entry.promise = hasUsableAlpha(angle.src).then(async (usable) => {
      const normal = usable ? angle.src : await buildFloodFillMask(angle.src);
      entry.normal = normal;
      entry.mirrored = await mirrorMaskImage(normal);
    });
    photoMaskCache.set(cacheKey, entry);
  }
  return entry.promise.then(() => angle.mirrored ? entry.mirrored : entry.normal);
}

function applyPhotoMask(layer, angle, stageW, stageH){
  getPhotoMask(angle).then(maskURL => {
    if(!maskURL) return;
    const t = coverTransform(stageW, stageH);
    const size = `${t.dw}px ${t.dh}px`;
    const pos = `${t.offsetX}px ${t.offsetY}px`;
    layer.style.maskImage = `url(${maskURL})`;
    layer.style.webkitMaskImage = `url(${maskURL})`;
    layer.style.maskSize = size;
    layer.style.webkitMaskSize = size;
    layer.style.maskPosition = pos;
    layer.style.webkitMaskPosition = pos;
  });
}

function pickDefaultAngle(){
  const angles = anglesForColor();
  if(angles.length === 0) return null;
  const threeQ = angles.find(a => a.id === 'threequarter');
  if(threeQ && angleCoversPlacements(threeQ) > 0) return threeQ.id;
  let best = angles[0], bestScore = -1;
  angles.forEach(a => { const s = angleCoversPlacements(a); if(s > bestScore){ bestScore = s; best = a; } });
  return best.id;
}

function renderAngleTabs(){
  const angles = anglesForColor();
  if(angles.length === 0){ angleTabs.innerHTML = ''; return; }
  angleTabs.innerHTML = angles.map(a => {
    const cov = angleCoversPlacements(a);
    return `<button class="angle-tab ${a.id===currentAngleId?'active':''}" data-angle="${a.id}">${angleLabel(a)}${cov>0?`<span class="cov">${cov}</span>`:''}</button>`;
  }).join('');
  angleTabs.querySelectorAll('.angle-tab').forEach(btn => {
    btn.onclick = () => { currentAngleId = btn.dataset.angle; renderPreview(); };
  });
}

function renderColorControl(){
  if(!state.product || !state.color) return;
  const btn = document.createElement('button');
  btn.className = 'color-btn';
  btn.innerHTML = `
    <span class="color-btn-dot" style="background:${state.color.hex}"></span>
    <span class="color-btn-labels">
      <span class="color-btn-eyebrow">Color</span>
      <span class="color-btn-name">${state.color.name}</span>
    </span>
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
  `;
  btn.onclick = () => { colorPanelOpen = true; renderPreview(); };
  previewStage.appendChild(btn);

  if(!colorPanelOpen) return;

  const scrim = document.createElement('div');
  scrim.className = 'color-scrim';
  scrim.onclick = () => { colorPanelOpen = false; renderPreview(); };
  previewStage.appendChild(scrim);

  const panel = document.createElement('div');
  panel.className = 'color-panel';
  panel.innerHTML = `
    <div class="color-panel-head">
      <span class="color-panel-title">Shell color — ${state.product.colors.length} available</span>
      <button class="color-panel-close" aria-label="Close">&#10005;</button>
    </div>
    <div class="color-panel-grid">
      ${state.product.colors.map(c => `
        <button class="color-opt ${c.name===state.color.name?'active':''}" data-color="${c.name}">
          <span class="color-opt-dot" style="background:${c.hex}"></span>${c.name}
        </button>`).join('')}
    </div>
  `;
  panel.querySelector('.color-panel-close').onclick = () => { colorPanelOpen = false; renderPreview(); };
  panel.querySelectorAll('[data-color]').forEach(b => {
    b.onclick = () => {
      state.color = state.product.colors.find(c => c.name === b.dataset.color);
      colorPanelOpen = false;
      currentAngleId = null;
      renderPreview();
      renderStep2Header();
      updatePricing();
    };
  });
  previewStage.appendChild(panel);
}

function renderStep2Header(){
  if(!state.product) return;
  document.getElementById('step2ProductName').textContent = state.product.name;
  document.getElementById('step2ProductMeta').textContent = `${state.color.name} · ${money(state.product.price)} ea`;
}

let previewRenderId = 0;

function renderPreview(){
  const myRenderId = ++previewRenderId;
  const angles = anglesForColor();
  renderAngleTabs();

  if(angles.length === 0){
    previewStage.innerHTML = '<div class="preview-empty">No product photos on file for this color yet.</div>';
    previewCaption.textContent = '';
    renderColorControl();
    return;
  }

  if(!currentAngleId || !angles.find(a => a.id === currentAngleId)) currentAngleId = pickDefaultAngle();
  const angle = angles.find(a => a.id === currentAngleId);

  previewStage.innerHTML = '';
  const photoEl = document.createElement('img');
  photoEl.className = 'product-photo';
  photoEl.src = angle.src;
  photoEl.alt = `${state.product.name} — ${angleLabel(angle)}`;
  photoEl.style.transform = angle.mirrored ? 'scaleX(-1)' : '';
  previewStage.appendChild(photoEl);

  const cat = CATALOG[state.type];
  if(cat.maxDims){
    const dimsLabel = document.createElement('div');
    dimsLabel.className = 'preview-maxdims';
    dimsLabel.textContent = `Max logo size: ${cat.maxDims.label}`;
    previewStage.appendChild(dimsLabel);
  }

  const paint = () => {
    /* A newer renderPreview() call has already taken over the stage
       since this one started loading its photo — skip painting so
       we don't draw a second, stale copy of the logo on top. */
    if(myRenderId !== previewRenderId) return;
    const stageW = previewStage.clientWidth;
    const stageH = photoEl.clientHeight || stageW;

    const maskLayer = document.createElement('div');
    maskLayer.className = 'logo-mask-layer';
    previewStage.appendChild(maskLayer);
    applyPhotoMask(maskLayer, angle, stageW, stageH);

    placements.forEach(p => {
      const zone = angle.zones && angle.zones[p.position];
      if(zone) drawWarp(zone, stageW, stageH, p.displayData, maskLayer);
    });

    if(isPlaceholderPreview(angle)){
      previewCaption.className = 'preview-caption placeholder-note';
      previewCaption.textContent = `This view is shown in White — your ${state.color.name} ${cat.noun} will be produced in ${state.color.name}.`;
    } else {
      previewCaption.className = 'preview-caption';
      previewCaption.textContent = '';
    }

    renderColorControl();
  };
  let painted = false;
  const paintOnce = () => { if(painted) return; painted = true; paint(); };
  photoEl.onload = paintOnce;
  if(photoEl.complete) paintOnce();
}

function drawWarp(zone, stageW, stageH, fileData, container){
  const tl = pctToPx(zone.tl, stageW, stageH);
  const tr = pctToPx(zone.tr, stageW, stageH);
  const br = pctToPx(zone.br, stageW, stageH);
  const bl = pctToPx(zone.bl, stageW, stageH);
  const matrix = project(REF_W, REF_H, tl, tr, br, bl);

  const warp = document.createElement('div');
  warp.className = 'logo-warp';
  warp.style.width = REF_W + 'px';
  warp.style.height = REF_H + 'px';
  warp.style.transform = matrix;
  warp.innerHTML = `<img src="${fileData || DEFAULT_LOGO_SRC}" alt="">`;
  (container || previewStage).appendChild(warp);
}

function render(){
  if(!state.product) return;
  renderStep2Header();
  renderPlacements();
  renderPreview();
  updatePricing();
}

function orderTotals(){
  const cat = CATALOG[state.type];
  const qty = parseInt(qtyInput.value) || cat.moq;
  const productLineTotal = state.product.price * qty;
  let subtotal = productLineTotal;
  const lines = [{ label:`${state.product.shortName || state.product.name} (${qty} × ${money(state.product.price)})`, value: productLineTotal, base:true }];

  placements.forEach(p => {
    const unit = unitPriceFor(state.type, p.method, p.colors, qty);
    const lineTotal = unit * qty;
    subtotal += lineTotal;
    const methodLabel = p.method === 'padprint' ? `${p.colors} color${p.colors>1?'s':''}` : 'full-color';
    lines.push({ label:`${titleCase(p.position)} logo — ${methodLabel}`, value: lineTotal, id:p.id, unit });
  });

  const uniqueCustomColors = new Set();
  placements.forEach(p => {
    if(p.method !== 'padprint') return;
    p.colorSlots.forEach(slot => {
      if(slot.kind === 'custom' && slot.value.trim()) uniqueCustomColors.add(slot.value.trim().toLowerCase());
    });
  });
  const pmsFee = uniqueCustomColors.size * 25;
  if(pmsFee > 0) lines.push({ label:`Custom color matching (${uniqueCustomColors.size} unique color${uniqueCustomColors.size>1?'s':''})`, value: pmsFee });

  return { qty, lines, total: subtotal + pmsFee };
}

function updatePricing(){
  if(!state.product) return;
  const cat = CATALOG[state.type];
  const { qty, lines, total } = orderTotals();

  const remaining = cat.moq - qty;
  if(remaining > 0){
    qtyNote.className = 'qty-chip warn';
    qtyNote.innerHTML = `Custom logos start at ${cat.moq} units — add ${remaining} more`;
  } else {
    qtyNote.className = 'qty-chip ok';
    qtyNote.innerHTML = `<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>${cat.moq}-unit minimum met`;
  }

  const first = placements[0];
  const brk = first ? nextBreakFor(state.type, first.method, first.colors, qty) : null;
  if(brk){
    priceBreakNote.style.display = '';
    priceBreakNote.innerHTML = `Add <strong>${brk.add} more</strong> to reach the ${brk.nextQty}+ price break — imprint drops to ${money(brk.price)}/ea.`;
  } else {
    priceBreakNote.style.display = 'none';
  }

  priceBreakdown.innerHTML = lines.map(l =>
    `<div class="price-line ${l.base?'base':''}"><span>${l.label}</span><span class="val">${money(l.value)}</span></div>`
  ).join('');
  estimateHint.textContent = `${lines.length} line${lines.length>1?'s':''}`;

  lines.forEach(l => {
    if(!l.id) return;
    const priceEl = placementList.querySelector(`[data-price="${l.id}"]`);
    if(priceEl) priceEl.textContent = `${money(l.unit)}/unit at this quantity`;
    const summaryPriceEl = placementList.querySelector(`[data-summary-price="${l.id}"]`);
    if(summaryPriceEl) summaryPriceEl.textContent = money(l.value);
  });

  totalAmt.textContent = money(total);

  const moqMet = qty >= cat.moq;
  const hasPlacement = placements.length > 0;
  const missingLogo = placements.find(p => !p.fileName);
  const disabled = !(moqMet && hasPlacement && !missingLogo);
  const label = !hasPlacement
    ? 'Choose where you want your logo'
    : missingLogo
      ? `Upload the ${missingLogo.position} logo to continue`
      : !moqMet
        ? `Add ${remaining} more units to order`
        : 'Continue to your details';

  ctaBtn.disabled = disabled;
  ctaBtn.textContent = label;
  mobileCtaBtn.disabled = disabled;
  mobileCtaBtn.textContent = disabled ? label : 'Continue';
  mobileBarInfo.innerHTML = `<div class="mobile-bar-eyebrow">Total</div><div class="mobile-bar-value">${money(total)}</div>`;
}

document.getElementById('qtyMinus').onclick = () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value)||1) - 1); render(); };
document.getElementById('qtyPlus').onclick = () => { qtyInput.value = (parseInt(qtyInput.value)||0) + 1; render(); };
qtyInput.addEventListener('input', () => {
  qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
  render();
});
qtyInput.addEventListener('blur', () => {
  let v = parseInt(qtyInput.value);
  if(!v || v < 1) v = 1;
  qtyInput.value = v;
  render();
});

function syncEstimateOpenState(){ estimateDetails.open = !isMobile(); }
syncEstimateOpenState();

const CUSTOMER = null;
const REQUIRED_FIELDS = ['custName','custCompany','custEmail','custPhone','custAddress1','custCity','custState','custZip'];

function renderOrderSummary(){
  const { qty, lines, total } = orderTotals();
  const photo = (state.color.angles && state.color.angles[0] && state.color.angles[0].src) || firstPhotoFor(state.product);

  document.getElementById('summaryProduct').innerHTML = `
    <div class="summary-thumb">${photo ? `<img src="${photo}" alt="">` : ''}</div>
    <div>
      <div class="summary-name">${state.product.name}</div>
      <div class="summary-meta">${state.color.name} · ${qty} units · ${money(state.product.price)} ea</div>
    </div>
  `;

  document.getElementById('summaryPlacements').innerHTML = placements.map(p => {
    const unit = unitPriceFor(state.type, p.method, p.colors, qty);
    const thumb = p.displayData || p.fileData;
    return `
      <div class="sp-row">
        <div class="sp-thumb">${thumb ? `<img src="${thumb}" alt="">` : ''}</div>
        <div class="sp-info">
          <div class="sp-title">${titleCase(p.position)} logo</div>
          <div class="sp-sub">${colorSummaryFor(p)}</div>
        </div>
        <span class="sp-price">${money(unit * qty)}</span>
      </div>`;
  }).join('');

  document.getElementById('summaryTotal').textContent = money(total);
}

function goToDetailsStep(){
  const map = { custName:'name', custCompany:'company', custEmail:'email', custPhone:'phone', custAddress1:'address1', custCity:'city', custState:'state', custZip:'zip' };
  Object.entries(map).forEach(([id, key]) => {
    const el = document.getElementById(id);
    if(CUSTOMER && CUSTOMER[key] && !el.value) el.value = CUSTOMER[key];
  });
  document.getElementById('detailsSub').textContent = CUSTOMER
    ? "We've filled this in from your account — update anything that's changed. Nothing is charged until you approve your proof."
    : "We'll review your artwork, have the printed proof made, and email it to you for approval. Nothing is charged until you approve it.";
  renderOrderSummary();
  step3Unlocked = true;
  goToStep(3);
}

ctaBtn.addEventListener('click', () => { if(!ctaBtn.disabled) goToDetailsStep(); });
mobileCtaBtn.addEventListener('click', () => { if(!mobileCtaBtn.disabled) goToDetailsStep(); });
document.getElementById('backToStep2Btn').addEventListener('click', () => goToStep(2));
document.getElementById('editOrderBtn').addEventListener('click', () => goToStep(2));

document.getElementById('submitRequestBtn').addEventListener('click', () => {
  const note = document.getElementById('detailsMissingNote');
  const missing = REQUIRED_FIELDS.filter(id => !document.getElementById(id).value.trim());
  REQUIRED_FIELDS.forEach(id => {
    document.getElementById(id).classList.toggle('invalid', missing.includes(id));
  });
  if(missing.length){
    note.textContent = 'Please fill in all fields before submitting.';
    document.getElementById(missing[0]).focus();
    return;
  }
  note.textContent = '';
  handleSubmitRequest();
});

function buildRequestPayload(){
  const { qty, total } = orderTotals();
  return {
    product: { id: state.product.id, handle: state.product.handle, name: state.product.name, sku: state.color.sku || state.product.sku, unitPrice: state.product.price },
    color: state.color.name,
    quantity: qty,
    estimateTotal: total,
    // ✅ FIX: Match Worker's expected shape
    placements: placements.map(p => {
      const unit = unitPriceFor(state.type, p.method, p.colors, qty);
      return {
        position: p.position,
        method: p.method,
        unitPrice: unit,           // ← ADD: needs this
        colors: p.colorSlots,      // ← RENAME from colorSlots to colors
        logoFileBase64: p.fileData, // ← RENAME from fileData to logoFileBase64
        logoFileName: p.fileName,   // ← RENAME from fileName to logoFileName
      };
    }),
    customer: {
      name: document.getElementById('custName').value.trim(),
      company: document.getElementById('custCompany').value.trim(),
      email: document.getElementById('custEmail').value.trim(),
      phone: document.getElementById('custPhone').value.trim(),
    },
    shippingAddress: {
      address1: document.getElementById('custAddress1').value.trim(),
      city: document.getElementById('custCity').value.trim(),
      state: document.getElementById('custState').value.trim(),
      zip: document.getElementById('custZip').value.trim(),
    },
    needBy: document.getElementById('custNeedBy').value || null,
    poNumber: document.getElementById('custPo').value.trim() || null,
    notes: document.getElementById('custNotes').value.trim() || null,
    // ✅ OPTIONAL: Add preview screenshots if you want them in the email
    previewScreenshots: [],
  };
}

function showConfirmation(payload){
  const { qty, total } = orderTotals();
  const photo = (state.color.angles && state.color.angles[0] && state.color.angles[0].src) || firstPhotoFor(state.product);
  const positions = placements.map(p => p.position).join(' + ');

  document.getElementById('confirmSub').innerHTML =
    `Request <strong>#${requestNumber}</strong>. A copy is on its way to ${payload.customer.email}. We'll be in touch shortly — usually the same business day.`;

  document.getElementById('confirmProduct').innerHTML = `
    <div class="summary-thumb">${photo ? `<img src="${photo}" alt="">` : ''}</div>
    <div>
      <div class="summary-name">${state.product.name}</div>
      <div class="summary-meta">${state.color.name} · ${qty} units · ${positions} logo${placements.length>1?'s':''}</div>
    </div>
  `;

  const needBy = payload.needBy
    ? new Date(payload.needBy + 'T00:00:00').toLocaleDateString(undefined, { month:'short', day:'numeric', year:'numeric' })
    : 'Not specified';

  document.getElementById('confirmFacts').innerHTML = `
    <div><div class="fact-label">Estimated total</div><div class="fact-value big">${money(total)}</div></div>
    <div><div class="fact-label">Shipping to</div><div class="fact-value">${payload.customer.company}<br>${payload.shippingAddress.address1}, ${payload.shippingAddress.city} ${payload.shippingAddress.state} ${payload.shippingAddress.zip}</div></div>
    <div><div class="fact-label">Needed by</div><div class="fact-value">${needBy}</div></div>
  `;

  document.getElementById('confirmContact').innerHTML =
    `Questions about this request? Call <strong>${CONTACT_PHONE}</strong> or email <a href="mailto:${CONTACT_EMAIL}">${CONTACT_EMAIL}</a> and quote #${requestNumber}.`;

  goToStep(4);
}

function handleSubmitRequest(){
  const btn = document.getElementById('submitRequestBtn');
  const payload = buildRequestPayload();
  requestNumber = 'WR-' + Math.floor(10000 + Math.random() * 89999);
  payload.requestNumber = requestNumber;

  const finish = () => showConfirmation(payload);

  if(!SUBMIT_ENDPOINT){
    finish();
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Sending…';
  fetch(SUBMIT_ENDPOINT, {
    method:'POST',
    headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify(payload)
  }).then(res => {
    if(!res.ok) throw new Error('Request failed');
    finish();
  }).catch(() => {
    const toast = document.getElementById('toast');
    toast.textContent = `Couldn't send that — please call ${CONTACT_PHONE}`;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3200);
  }).finally(() => {
    btn.disabled = false;
    btn.textContent = 'Send my proof request';
  });
}

document.getElementById('restartBtn').addEventListener('click', () => {
  state.product = null; state.color = null;
  placements = []; pIdCounter = 0;
  step2Unlocked = false; step3Unlocked = false;
  requestNumber = null;
  selectBar.style.display = 'none';
  renderCatRow();
  renderModelGrid();
  goToStep(1);
});

window.addEventListener('resize', () => {
  syncEstimateOpenState();
  if(globalLogo && document.getElementById('panel1').classList.contains('active')) renderModelGrid();
  if(state.product && document.getElementById('panel2').classList.contains('active')) renderPreview();
});

/* ---------------------------------------------------------
   GLOBAL LOGO — uploaded once in the step 1 header, configured in
   the logo setup modal (print type, ink, background), previewed on
   every model card, and used to prefill each placement in step 2.
--------------------------------------------------------- */
let globalLogo = null; // { fileName, fileData, displayData, mode:'single'|'multi'|'full', ink, count, bgRemoved }
let logoSetup = null;
let logoSetupRun = 0;
let logoSkipped = false;
const globalLogoSlot = document.getElementById('globalLogoSlot');
const logoSetupOverlay = document.getElementById('logoSetupOverlay');
const logoSetupBody = document.getElementById('logoSetupBody');
const logoSetupSave = document.getElementById('logoSetupSave');

const SETUP_MODES = [
  { key:'single', name:'1 color',    hint:'One solid ink. Most affordable.' },
  { key:'multi',  name:'2–4 colors', hint:'Solid inks, no gradients.' },
  { key:'full',   name:'Full color', hint:'Gradients, photos, detail.' },
];

function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
}

/* Header copy lives on CATEGORY_META (headline + sub per category). */
function updateHeadline(){
  const meta = CATEGORY_META.find(m => m.key === state.type);
  if(!meta) return;
  document.getElementById('toolHeadline').textContent = meta.headline;
  document.querySelector('#toolHero .panel-sub').textContent = meta.sub;
}

/* Lowest imprint price in the category (any method, any tier) + margin.
   Shown per card so the header never has to state a price. */
function logoFromLabel(key){
  const cat = CATALOG[key];
  if(!cat) return '';
  const pad = cat.methods.padprint.tiers.map(t => t.prices[1]);
  const pvc = cat.methods.pvc.tiers.map(t => t.price);
  const low = Math.min(...pad, ...pvc) * LOGO_PRICE_MARGIN;
  return `Logo from ${money(low)}/unit · ${cat.moq} min`;
}

function globalLogoSummary(g){
  if(g.mode === 'single') return `1 color · ${g.ink}`;
  const base = g.mode === 'multi' ? `${g.count} colors` : 'Full color';
  return g.bgRemoved ? `${base} · background removed` : base;
}

function readLogoFile(file){
  if(!file || !file.type || file.type.indexOf('image/') !== 0) return;
  const reader = new FileReader();
  reader.onload = (e) => openLogoSetup({ fileName:file.name, fileData:e.target.result, mode:'single', ink:'Black', count:2, bgRemoved:false });
  reader.readAsDataURL(file);
}

function renderGlobalLogo(){
  if(!globalLogoSlot) return;
  if(!globalLogo){
    globalLogoSlot.innerHTML = `
      <label class="logo-drop" id="logoDrop">
        <input type="file" accept="image/*" id="globalLogoInput" style="display:none;">
        <span class="logo-drop-title">Drop your logo here</span>
        <span class="cta">Upload logo</span>
      </label>`;
    const drop = document.getElementById('logoDrop');
    const logoInput = document.getElementById('globalLogoInput');
    const skipBtn = document.getElementById('logoSkipBtn');
    
    if(logoInput) {
      logoInput.onchange = (e) => { readLogoFile(e.target.files[0]); e.target.value = ''; };
    }
    if(drop) {
      drop.addEventListener('dragover', (e) => { e.preventDefault(); drop.classList.add('dragging'); });
      drop.addEventListener('dragleave', () => drop.classList.remove('dragging'));
      drop.addEventListener('drop', (e) => { e.preventDefault(); drop.classList.remove('dragging'); readLogoFile(e.dataTransfer.files[0]); });
    }
    if(skipBtn) {
      skipBtn.onclick = (e) => {
        e.preventDefault(); e.stopPropagation();
        logoSkipped = true; renderGlobalLogo();
        window.scrollTo({ top: catRow.getBoundingClientRect().top + window.scrollY - 20, behavior:'smooth' });
      };
    }
    return;
  }
  globalLogoSlot.innerHTML = `
    <div class="logo-card">
      <div class="logo-card-thumb"><img src="${globalLogo.displayData}" alt=""></div>
      <div class="logo-card-info">
        <div class="section-title">Your logo</div>
        <div class="logo-card-name">${escapeHtml(globalLogo.fileName)}</div>
        <div class="logo-card-meta">${globalLogoSummary(globalLogo)}</div>
      </div>
      <div class="logo-card-actions">
        <button type="button" class="collapsed-edit" id="globalLogoEdit">Edit</button>
        <label class="change-link"><input type="file" accept="image/*" id="globalLogoReplace" style="display:none;">Replace</label>
        <button type="button" class="change-link" id="globalLogoRemove">Remove</button>
      </div>
    </div>`;
  const editBtn = document.getElementById('globalLogoEdit');
  const replaceInput = document.getElementById('globalLogoReplace');
  const removeBtn = document.getElementById('globalLogoRemove');
  
  if(editBtn) {
    editBtn.onclick = () => openLogoSetup({ ...globalLogo });
  }
  if(replaceInput) {
    replaceInput.onchange = (e) => { readLogoFile(e.target.files[0]); e.target.value = ''; };
  }
  if(removeBtn) {
    removeBtn.onclick = () => { globalLogo = null; renderGlobalLogo(); renderModelGrid(); };
  }
}

function openLogoSetup(data){
  logoSetup = { ...data, preview: data.displayData || data.fileData, busy:false };
  document.getElementById('setupFileName').textContent = data.fileName;
  logoSetupOverlay.classList.add('open');
  processLogoSetup();
}
function closeLogoSetup(){ logoSetupOverlay.classList.remove('open'); logoSetup = null; }

/* Reuses the same recolor / background-removal functions as step 2,
   so the preview here matches what the placement shows later. */
function processLogoSetup(){
  const s = logoSetup;
  if(!s) return;
  const run = ++logoSetupRun;
  let job = null;
  if(s.mode === 'single') job = recolorToStockColor(s.fileData, stockColorByName(s.ink).hex);
  else if(s.bgRemoved) job = removeFlatBackground(s.fileData);
  if(!job){ s.preview = s.fileData; s.busy = false; renderLogoSetup(); return; }
  s.busy = true; renderLogoSetup();
  job.then(result => {
    if(run !== logoSetupRun || logoSetup !== s) return;
    s.preview = result; s.busy = false; renderLogoSetup();
  });
}

function renderLogoSetup(){
  const s = logoSetup;
  if(!s) return;
  const cat = CATALOG[state.type];
  const scroll = logoSetupBody.scrollTop;
  let options = '';
  if(s.mode === 'single'){
    options = `
      <div>
        <div class="setup-row-head"><div class="section-title">Ink color</div><div class="setup-ink-name">${stockColorLabel(stockColorByName(s.ink))}</div></div>
        <div class="setup-inks">${STOCK_COLORS.map(c => `<button type="button" class="setup-ink ${c.name===s.ink?'active':''}" data-ink="${c.name}" title="${c.name}" aria-label="${c.name}" style="background:${c.hex}"></button>`).join('')}</div>
        <div class="setup-hint">Background is removed automatically for 1-color logos. Need a color that isn't listed? You can describe it in the next step.</div>
      </div>`;
  } else {
    options = `
      ${s.mode === 'multi' ? `
      <div>
        <div class="section-title">How many ink colors?</div>
        <div class="setup-counts">${[2,3,4].map(n => `<button type="button" class="setup-count ${s.count===n?'active':''}" data-count="${n}">${n} colors</button>`).join('')}</div>
      </div>
      <div class="modal-note">Multi-color logos preview in your original artwork colors. We'll match each ink and show the exact colors on your proof.</div>` : ''}
      <label class="modal-bgrow">
        <input type="checkbox" id="setupBgRemove" ${s.bgRemoved?'checked':''}>
        <span><strong>Remove background</strong><br>Use if your file has a plain white or solid backdrop.</span>
      </label>`;
  }
  logoSetupBody.innerHTML = `
    <div class="setup-preview ${s.busy?'busy':''}">
      <img src="${s.preview}" alt="">
      ${s.busy ? '<span class="setup-busy">Updating…</span>' : ''}
    </div>
    ${cat && cat.maxDims ? `<div class="modal-note">Max logo size for ${cat.label.toLowerCase()}: ${cat.maxDims.label}</div>` : ''}
    <div>
      <div class="section-title">How should it print?</div>
      <div class="setup-modes">${SETUP_MODES.map(m => `<button type="button" class="setup-mode ${s.mode===m.key?'active':''}" data-mode="${m.key}"><span class="setup-mode-name">${m.name}</span><span class="setup-mode-hint">${m.hint}</span></button>`).join('')}</div>
    </div>
    ${options}`;
  logoSetupBody.scrollTop = scroll;
  logoSetupBody.querySelectorAll('[data-mode]').forEach(b => { b.onclick = () => { s.mode = b.dataset.mode; processLogoSetup(); }; });
  logoSetupBody.querySelectorAll('[data-ink]').forEach(b => { b.onclick = () => { s.ink = b.dataset.ink; processLogoSetup(); }; });
  logoSetupBody.querySelectorAll('[data-count]').forEach(b => { b.onclick = () => { s.count = parseInt(b.dataset.count); renderLogoSetup(); }; });
  const bg = document.getElementById('setupBgRemove');
  if(bg) bg.onchange = (e) => { s.bgRemoved = e.target.checked; processLogoSetup(); };
  logoSetupSave.disabled = s.busy;
}

document.getElementById('logoSetupClose').onclick = closeLogoSetup;
document.getElementById('logoSetupCancel').onclick = closeLogoSetup;
logoSetupOverlay.addEventListener('click', (e) => { if(e.target === logoSetupOverlay) closeLogoSetup(); });
logoSetupSave.addEventListener('click', () => {
  const s = logoSetup;
  if(!s || s.busy) return;
  globalLogo = { fileName:s.fileName, fileData:s.fileData, displayData:s.preview, mode:s.mode, ink:s.ink, count:s.count, bgRemoved:s.bgRemoved };
  closeLogoSetup();
  renderGlobalLogo();
  renderModelGrid();
});

/* Prefills a step 2 placement from the global logo so nothing has to
   be re-entered. Customers can still change anything per placement. */
function applyGlobalLogoTo(p){
  if(!globalLogo || !p) return;
  p.fileName = globalLogo.fileName;
  p.fileData = globalLogo.fileData;
  p.displayData = globalLogo.displayData;
  p.bgRemoved = globalLogo.bgRemoved;
  if(globalLogo.mode === 'full'){
    p.method = 'pvc'; p.colors = 1; p.colorSlots = makeColorSlots(1); p.recolored = false;
  } else if(globalLogo.mode === 'multi'){
    p.method = 'padprint'; p.colors = globalLogo.count; p.colorSlots = makeColorSlots(globalLogo.count); p.recolored = false;
  } else {
    p.method = 'padprint'; p.colors = 1; p.colorSlots = [{ kind:'stock', value: globalLogo.ink }]; p.recolored = true;
  }
}

/* Draws the global logo into the card photo using the product's front
   zone (falls back to its first zone). Card photos are object-fit:contain,
   so zone % are mapped through a contain transform, not the cover one. */
function paintCardLogo(card, prod){
  if(!globalLogo) return;
  let angle = null;
  for(const c of prod.colors){ if(c.angles && c.angles.length){ angle = c.angles[0]; break; } }
  if(!angle || !angle.zones) return;
  const zone = angle.zones.front || Object.values(angle.zones)[0];
  if(!zone) return;
  const wrap = card.querySelector('.model-photo');
  const img = wrap && wrap.querySelector('img');
  if(!img) return;
  const paint = () => {
    const W = wrap.clientWidth, H = wrap.clientHeight;
    if(!W || !img.naturalWidth) return;
    const scale = Math.min(W / img.naturalWidth, H / img.naturalHeight);
    const dw = img.naturalWidth * scale, dh = img.naturalHeight * scale;
    const ox = (W - dw) / 2, oy = (H - dh) / 2;
    const pt = (p) => ({ x: ox + (p.x / 100) * dw, y: oy + (p.y / 100) * dh });
    wrap.querySelectorAll('.logo-warp').forEach(n => n.remove());
    const warp = document.createElement('div');
    warp.className = 'logo-warp';
    warp.style.width = REF_W + 'px';
    warp.style.height = REF_H + 'px';
    warp.style.transform = project(REF_W, REF_H, pt(zone.tl), pt(zone.tr), pt(zone.br), pt(zone.bl));
    warp.innerHTML = `<img src="${globalLogo.displayData}" alt="">`;
    wrap.appendChild(warp);
  };
  if(img.complete) paint(); else img.addEventListener('load', paint, { once:true });
}

/* Deep link from the product-page banner / buy-box module:
   /pages/customize?product=<handle>&color=<name> preselects the product
   and shell color on step 1, leaving the logo upload as the next action. */
function applyDeepLink(){
  const params = new URLSearchParams(window.location.search);
  const handle = params.get('product');
  if(!handle) return;
  for(const key of Object.keys(CATALOG)){
    if(!categoryHasProducts(key)) continue;
    const prod = CATALOG[key].products.find(p => p.handle === handle);
    if(!prod) continue;
    const want = (params.get('color') || '').toLowerCase();
    state.type = key;
    state.product = prod;
    state.color = prod.colors.find(c => c.name.toLowerCase() === want) || defaultColorFor(prod);
    return;
  }
}

applyDeepLink();
renderCatRow();
renderModelGrid();
renderGlobalLogo();


  } catch(e) { console.error(e); }
})();
})();
